import React from "react";
import ReactApexChart from "react-apexcharts";
import { Row, Col, Typography, Spin, Card, Space, Divider } from "antd";

function EChart({ activeUsersByDate, loading }) {
  const { Title, Paragraph, Text } = Typography;

  const chartSeries = [
    {
      name: "Active Users",
      data: activeUsersByDate?.map((item) => item.users) || [],
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      width: "100%",
      height: "auto",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "55%", borderRadius: 5 },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 1, colors: ["transparent"] },
    grid: { show: true, borderColor: "#ccc", strokeDashArray: 2 },
    xaxis: {
      categories: activeUsersByDate?.map((item) => item.date) || [],
    },
    yaxis: {
      labels: {},
    },
    tooltip: {
      y: { formatter: (val) => val + " users" },
    },
  };

  const totalUsers = chartSeries[0].data.reduce((sum, val) => sum + val, 0);



  if (loading) return <Spin tip="Loading chart..." />;

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card bordered={false}>
        <ReactApexChart
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={220}
        />
      </Card>

      {/* <Card bordered={false}>
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
          <Title level={5}>Active Users</Title>
          <Paragraph>
            Than last week <Text strong style={{ color: "#52c41a" }}>+30%</Text>
          </Paragraph>
          <Paragraph type="secondary">
            We have created multiple options for you to put together and customize into pixel-perfect pages.
          </Paragraph>

          <Divider />

          <Row gutter={[16, 16]}>
            {items.map((item, index) => (
              <Col xs={12} sm={12} md={6} key={index}>
                <Card bordered={false}>
                  <Title level={4}>{item.value}</Title>
                  <Text>{item.title}</Text>
                </Card>
              </Col>
            ))}
          </Row>
        </Space>
      </Card> */}
    </Space>
  );
}

export default EChart;
